import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loggedout',
  templateUrl: './loggedout.component.html',
  styleUrls: ['./loggedout.component.css']
})
export class LoggedoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
